import React, { useContext } from "react";
import { ProduitInterface } from "dataProvider/Produit";
import { IntlContext } from "context";
import NutriScore from "./NutriScore";
import Tooltip from "ui/Form/Element/Tooltip";

export interface DescriptionsProps {
    produit: ProduitInterface | any;
}

const Descriptions: React.FC<DescriptionsProps> = ({ produit, children }) => {
    const intl = useContext(IntlContext);

    return (
        <div className="product-informations__block">
            <h2 className="information__title">{intl.formatMessage("produit.fiche.label.description_produit")}</h2>
            <span className="information__product-code">
                <span className="font-bold">{intl.formatMessage("produit.fiche.label.code_produit")} : </span>
                {produit?.id}
            </span>
            <div className="information__ingredients">
                <div className="information__ingredients--list">
                    <div>
                        <span className="font-bold">{intl.formatMessage("produit.fiche.label.nom_produit")} : </span>
                        {produit?.libel}
                    </div>
                    <div>
                        <span className="font-bold">{intl.formatMessage("produit.fiche.label.marque")} : </span>
                        {produit?.marque_libel}
                    </div>
                    {produit?.denomination_vente && (
                        <div>
                            <br />
                            <span className="font-bold">
                                {intl.formatMessage("produit.fiche.label.denomination_vente")} :{" "}
                            </span>
                            {produit?.denomination_vente}
                        </div>
                    )}
                </div>
                <div className="information__ingredients-nutriscore">
                    <NutriScore value={produit?.etiquetage_simplifie_score_libel} />
                </div>
            </div>
            {produit?.code_barre && (
                <div className="information__codebarre">
                    <span className="font-bold">{intl.formatMessage("produit.label.code_barre")} : </span>
                    <span>
                        {produit?.code_barre} {produit?.add_on}
                    </span>
                </div>
            )}
            <ul className="list-none">
                {produit?.secteur?.interface?.name && (
                    <li>
                        <span className="font-bold">
                            {intl.formatMessage("produit.label.secteur")}
                            <Tooltip value={intl.formatMessage("produit.fiche.tooltip.secteur")} />:{" "}
                        </span>
                        <span>{produit?.secteur?.interface?.name}</span>
                    </li>
                )}

                {produit?.famille?.interface?.name && (
                    <li>
                        <span className="font-bold">
                            {intl.formatMessage("produit.label.famille")}
                            <Tooltip value={intl.formatMessage("produit.fiche.tooltip.famille")} />:{" "}
                        </span>
                        <span>{produit?.famille?.interface?.name}</span>
                    </li>
                )}

                {produit?.poids_net_g && (
                    <li>
                        <span className="font-bold">{intl.formatMessage("produit.label.poids_net")} : </span>
                        <span>
                            {produit?.poids_net_g} {produit?.unitemesure_poids_net_libel}{" "}
                            {produit?.poids_net_egoutte_g && (
                                <React.Fragment>
                                    ({intl.formatMessage("produit.label.poids_net_egoutte")} :{" "}
                                    {produit?.poids_net_egoutte_g}
                                    {produit?.unitemesure_poids_net_egoutte_libel})
                                </React.Fragment>
                            )}
                        </span>
                    </li>
                )}

                {produit?.volume_net_mL && (
                    <li>
                        <span className="font-bold">{intl.formatMessage("produit.label.volume_net")} : </span>
                        <span>{produit?.volume_net_mL}mL</span>
                    </li>
                )}

                {produit?.nb_unite > 0 && (
                    <li>
                        <span className="font-bold">{intl.formatMessage("produit.label.nb_unite_par_lot")} : </span>
                        <span>{produit?.nb_unite}</span>
                    </li>
                )}
                {Array.isArray(produit?.annee_prelevement) && produit?.annee_prelevement.length && (
                    <li>
                        <span className="font-bold">
                            {intl.formatMessage("produit.fiche.label.annee_prelevement")}
                            <Tooltip value={intl.formatMessage("produit.fiche.tooltip.annee_prelevement")} />:{" "}
                        </span>
                        <span>{produit?.annee_prelevement.join(", ")}</span>
                    </li>
                )}

                {produit?.mode_conservation_libel && (
                    <li>
                        <span className="font-bold">
                            {intl.formatMessage("produit.fiche.label.mode_conservation")} :{" "}
                        </span>
                        <span>{produit?.mode_conservation_libel}</span>
                    </li>
                )}

                {produit?.segment_libel && (
                    <li>
                        <span className="font-bold">{intl.formatMessage("produit.fiche.label.type_marque")} : </span>
                        <span>{produit?.segment_libel}</span>
                    </li>
                )}
            </ul>

            {children}
        </div>
    );
};

export default Descriptions;
